'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _next = require('@alifd/next');

require('./view.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Tooltip = _next.Balloon.Tooltip;

var GroupLayout = function (_React$Component) {
  _inherits(GroupLayout, _React$Component);

  function GroupLayout() {
    _classCallCheck(this, GroupLayout);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  GroupLayout.prototype.renderDescription = function renderDescription() {
    var description = this.props.description;

    if (description) {
      return _react2.default.createElement(
        Tooltip,
        { trigger: _react2.default.createElement(_next.Icon, { type: 'prompt', className: 'icon-description' }), align: 'r' },
        description
      );
    }

    return null;
  };

  GroupLayout.prototype.renderTitle = function renderTitle() {
    var _props = this.props,
        title = _props.title,
        subTitle = _props.subTitle;

    return subTitle ? title + '(' + subTitle + ')' : '' + title;
  };

  GroupLayout.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        title = _props2.title,
        visible = _props2.visible,
        hiddenAll = _props2.hiddenAll,
        disableFieldSelect = _props2.disableFieldSelect;


    if (hiddenAll) {
      return null;
    }

    return (0, _lodash.isEmpty)(children) ? null : _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)('vc-group-layout') },
      visible !== false && title && _react2.default.createElement(
        'div',
        { className: 'vc-group-layout-title' },
        this.renderTitle(),
        this.renderDescription()
      ),
      _react2.default.createElement(
        'div',
        { className: 'vc-container' },
        _react2.default.Children.map(children, function (child, i) {
          return _react2.default.cloneElement(child, _extends({}, child.props, {
            disableFieldSelect: disableFieldSelect // 透传表单选择模式禁用态，为了做到复杂组件中引入布局组件导致被嵌套的基础组件出现表单选择模式
          }));
        })
      ),
      _react2.default.createElement('div', { className: 'vc-group-layout-footer' })
    );
  };

  return GroupLayout;
}(_react2.default.Component);

GroupLayout.defaultProps = {
  title: '',
  description: ''
};

GroupLayout.propTypes = {
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  behavior: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

GroupLayout.displayName = 'GroupLayout';

exports.default = GroupLayout;
module.exports = exports['default'];